import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import {withRouter} from 'react-router-dom';
import Modal from 'react-responsive-modal';
import ReactGA from 'react-ga';
import moment from 'moment';
import Rating from 'react-star-rating-component';
import {Helmet} from "react-helmet";
import { Checkbox } from 'semantic-ui-react';
import Slider from 'react-slick';
import Responsive from 'react-responsive';
// const Tutorial = !!global.window && require('react-joyride').default;
import Tutorial,{ ACTIONS, EVENTS, STATUS } from 'react-joyride';
import Countdown from 'react-countdown-now';


import './Recommendations.css';
// import '../../components/Recommendations/MessengerChat.css';
import '../../components/onboarding/StickyHeader.css';
import {  
	CategoryHolder,
	CategoryTitle,
	CategorySmallTitle,
	InformationButton,
	sliderSettings
} from './RecommendationsStyles';
import './RecommendationsAdditionalCategories.css';
import './RecommendationsBundle.css';


import Api from '../../utils/api';
import HttpUtils from '../../utils/http';
import { Elements } from 'react-stripe-elements';
import * as zenscroll from 'zenscroll';
import * as util from '../../utils/util';
import { isMobile } from "../../utils/util";
import { RESPONSE_STATUS } from '../../utils/constants';
import { addOrDeleteCartGoodsData,deleteAllCartGoodsData,getUserCartData } from '../../actions/cartAction';


import LoadingBlock from '../../components/common/LoadingBlock';
import ProductReview from '../../components/skinprofile/ProductReview';
import RecommendationsSeparateView from './RecommendationsSeparateView';
import RecommendationsCheckout from './RecommendationsCheckout';
// import StickyHeader from '../../components/onboarding/StickyHeader';
import StepsHeader from '../../components/header/StepsHeader';
import ReviewProduct from  "../../components/review/reviewProduct";
import LoadingWrapper from '../../hocs/RecommendationsFetcher';
import Product from '../../components/product/Product';
import regiment from '../../data/regiment.json';
import ProductNotFound from '../../components/product/ProductNotFound';
import Product_categoryHolder from './Recommendations_categoryHolder';
import EstheticianPicksConten from './EstheticianPicksConten'


// import { EVENTS } from 'react-joyride';



let width = 198;
var  tutorialSteps_2_target = '.slick-active:nth-child(2) .add-to-wishlist-heart';
// if (window.innerWidth > 1443) {
// 	width = 331;
// 	tutorialSteps_2_target ='.slick-arrow.slick-next';

// }else
 if (window.innerWidth > 768) {
	width = 331;
	tutorialSteps_2_target ='.slick-arrow.slick-next';
}else if (window.innerWidth > 480) {
	width = 331;
	tutorialSteps_2_target ='.slick-arrow.slick-next';
}

// 教程配置，教程功能已关闭
const tutorialSteps = [
	// {
	// 		target: '.timer-container-zone',
	// 		content: <div className="tutorial-modal-content"><h3 className="tu-step-1-h3">You have 3 days</h3><p className="tu-step-1-p">Modify your cart within this time with your skin advisors via text</p></div>,
	// 		placement: 'bottom',
	// 		disableBeacon: true,
	// 		title:  window.innerWidth > 1443 ? '1 of 3' : '1 of 4',
	// 		styles:{
	// 			tooltip:{
	// 				width:width
	// 			},
	// 			tooltipContainer:{
	// 				borderBottom: 'solid 0.5px var(--pale-salmon)',
	// 				marginBottom: '10px',
	// 				paddingBottom: '7px',
	// 			},
	// 			tooltipFooter:{
	// 				marginTop: 0,
	// 			}
	// 		}
	// },


	{
			target: tutorialSteps_2_target,
			content: <div className="tutorial-modal-content"> <object class="mobile-tutorial-2" type="image/svg+xml" data="/images/recommendations/swipe-icon.svg"/> <h3 className="tu-step-1-h3">You have more options</h3><p className="tu-step-2-p">scroll more to see what your skin advisors picked</p></div>,
			placement: 'auto',
			disableBeacon: true,
			title: '1 of 3',
			styles:{
				tooltip:{
					width:width
				},
				tooltipContainer:{
					borderBottom: 'solid 0.5px var(--pale-salmon)',
					marginBottom: '10px',
					paddingBottom: '7px',
				}
			}
	},
	{
			target: '.product',
			content: <div className="tutorial-modal-content"><h3 className="tu-step-1-h3">Read about the product</h3><p className="tu-step-2-p">Click on the products to see how it will address your skin concerns</p></div>,
			placement: 'right',
			disableBeacon: true,
			title: '2 of 3',
			styles:{
				tooltip:{
					width:width
				},
				tooltipContainer:{
					borderBottom: 'solid 0.5px var(--pale-salmon)',
					marginBottom: '10px',
					paddingBottom: '7px',
				},
			}
	},
	{
			target: '.add-to-wishlist-heart',
			content: <div className="tutorial-modal-content"><h3 className="tu-step-1-h3">Like it!</h3><p className="tu-step-2-p">Also, you can save it for later, and can be easily found in wishlist.</p></div>,
			placement: 'right',
			disableBeacon: true,
			title:  '3 of 3',
			styles:{
				tooltip:{
					width:width
				},
				tooltipContainer:{
					borderBottom: 'solid 0.5px var(--pale-salmon)',
					marginBottom: '10px',
					paddingBottom: '7px',
				},
			}
	}
];

// let name = localStorage.getItem('user_firstname');
const indexMapProductsLabeled = {"cleanser":1,"exfoliator":2,"serum":3,"toner":4,"moisturizer":5,"spf":6,"eye cream":7,"mask":8,"make-up remover":11,"treatment":12,"supplement":15};

const indexMapProductsLabeledBaseline = {"cleanser":1,"toner":2,"moisturizer":3,"spf":4,"make-up remover":5};
const indexMapProductsLabeledTarget  = {"serum":1,"treatment":2,"exfoliator":3};
const indexMapProductsLabeledAboveAndBeyond  = {"mask":1,"supplement":2,"eye cream":3};


class Recommendations extends Component {
    constructor(props){
		super(props);
				
		this.handleOpenAdditionalCategories = this.handleOpenAdditionalCategories.bind(this);
		this.closeReviewModal = this.closeReviewModal.bind(this);
		this.fun_recNavigationSection = this.fun_recNavigationSection.bind(this);
		this.fun_leavingMoreOpen = this.fun_leavingMoreOpen.bind(this);

		this.productsArr = [];
		this.price = "";
		this.authToken = Api.auth_tokenManager();
		this.userId = localStorage.getItem("user_id");
		this.firstProdInRowArr = [];
		this.mounted = false;

		this.state = {
			isFirstTime: false,
			loading: true,
			loadingPurchase: false,
			recommendedProducts: [],
			productCart: [],
			productArr: [],
			productViews: [],
			target_productViews:[],
			aboveAndBeyond_productViews:[],
			userPaidGateFee: false,
			productTypes: [],
			price: "0.00",
			optInTimerStarted: false,
			optInStartTime: null,
			runTutorial: false,
			showThankYou: false,
			optInTimerFinished: false,
			eligibleForDiscount: false,
			eligibleGatePaid: false,
			eligibleCardOnStripe: false,
			eligiblePreviouslyPurchased: false,
			openCancelModal: false,
			defaultPurchaseStatus: '',
			openAdditionalCategories: false,
			orderEnd:false, // Whether to complete the purchase
			orderId: '',
			orderSubtotal: 0,
			isUserPhoneEndNumber: true,
			amountPaidGateFee: '',
			openHomeConfirmModal:true,
			user_flags_show_recommendation:'',
			openReviewModal: false,
			openPaymentConfirmModal:false,
			productInfo:[],
			planValue:'',
			planTier:'',
			paymentType: '',
			openScheduleConfirmModal:false,
			oneVisitSchedule:false,  // 选择了免费的plan ，第一次访问产品推荐页面，延迟45秒，看到need help deciding. 以后再进来，就直接看到minni need
			skinTypeOneWord:'',
			navigationSectionName:'buildaHealthySkinBaseline_id',
			estheticianNote:'',
			leavingMoreOpen:false,
		}

	}
	
	componentWillMount() {
    	if (localStorage.getItem("user_id")) {
			// this.getAdditionalRecommendations(); // 获取用户可能喜欢的推荐产品
			try {
				this.setState({planValue : this.props.location.state.planValue, paymentType: this.props.location.state.paymentType });
			} catch (error) {
				this.setState({planValue : '',paymentType:'' });
			}

			 // 用户信息没缓存起来，就重新获取下
			if(!localStorage.getItem("user_account_info") && localStorage.getItem("auth_token")){
				Api.fun_getGenderId().then(()=>{
					this.fun_getUserSkinType();
					this.fun_getUserSignupSource();
				})
			}else{
				this.fun_getUserSkinType();
				this.fun_getUserSignupSource();
			}
			
    	}

		// window.onresize = function (){
		
		// }
	}

	


  	componentDidMount() {

		// var recommendationDom = document.getElementById("recommendation-page");
		// recommendationDom.addEventListener('touchstart', this.touchStart);
		// recommendationDom.addEventListener('touchmove', this.preventTouch, {passive: false});

		document.documentElement.scrollTop = 0
		this.mounted = true;

		
		window.addEventListener('scroll', this.handleScroll);
		

		// Judge user's first visit recommendaton view.show Course
		if (localStorage.getItem("user_id")) {
      		if (localStorage.getItem("gift_user")) localStorage.removeItem("gift_user");
					localStorage.removeItem("url_visited_recommendations");
      //判断手机号码尾号是否为5 - 9
    //   var phoneNumber = localStorage.getItem("phone_number");
    //   if(phoneNumber && phoneNumber != null){
    //           var phoneEndNumber = phoneNumber.substring(phoneNumber.length-1);
    //           if((phoneEndNumber*1) >= 5 ){
    //             this.setState({isUserPhoneEndNumber:false})
    //     }
	//   }
	// 判断用户来源网站是否是指定的那些，为 true ，关闭时间提示  合作结束功能关闭了
		// if(sessionStorage.getItem("utm_source") || localStorage.getItem("user_global_hasPaid") != 'false' ){
		// 	this.setState({isUserPhoneEndNumber:false})
		// }

			// 判断用户是否第一次进去recommend view
			const showRecommendationFlag = localStorage.getItem("visited_recommendations");
		
			if (showRecommendationFlag == "false" || showRecommendationFlag == null) {
				this.setState({ isFirstTime: true });
				localStorage.setItem("visited_recommendations",true);
				// 判断是否是第一次进去这页面，打开教程。打开教程前。需要判断用户是否第一次购买，和加载推荐商品
				fetch('/api/user-flags/show-recommendation?user-id=' + this.userId, {
					method: 'GET',
					headers: {
						'x-auth-token': Api.auth_tokenManager()
					}
				}).then(response => response.text()).then(status => {
					this.setState({
						user_flags_show_recommendation: status
					})					
					 if (status == 'false') {
						fetch("/api/user-flags", {
						method: 'PATCH',
						headers: {
								'Accept': 'application/json',
								'Content-Type': 'application/json',
								'x-auth-token': Api.auth_tokenManager()
						},
						body: JSON.stringify({
								userId: this.userId,
								showRecommendation: true
						})
						}).then(response => {

						});
					}
				});
			}else{
				this.setState({
					oneVisitSchedule:true,
					openScheduleConfirmModal:false
				})
			}


			// 获取用户选择的plan
			this.getPlanTypeTierData()

			//Fetch data
			const userId = this.userId;
			const fetchedCartWithProducts = localStorage.getItem("recommendations_cart_fetched_with_prod");
			const fetchedProductTypes = localStorage.getItem("recommendations_fetched_product_types");
			const fetchedRecommendations = localStorage.getItem("recommendations_fetched");
			const fetchedDpStatus = (localStorage.getItem("recodpstatus") && localStorage.getItem("recodpstart")) && localStorage.getItem("recodppurchase");
			
			const promiseGetAccountInfo = new Promise((res, rej) => {
				// this.getAccountInfo().then(() => {return res()});
					this.setState({ 
						firstName: localStorage.getItem("user_global_firstname"),
						lastName: localStorage.getItem("user_global_lastname"),
						phoneNumber: localStorage.getItem("user_global_phone"), 
						email: localStorage.getItem("user_global_email"),
					},()=>{
						return res()
					});
			})

		
			
			const promiseFetchReco = new Promise((res, rej) => {
				if (!fetchedRecommendations || !fetchedProductTypes) {
					this.fetchRecommendedProducts(false, () => {
						return res(this.state.recommendedProducts);	
					});
				} else {
					this.setState({ recommendedProducts: JSON.parse(fetchedRecommendations), productTypes: JSON.parse(fetchedProductTypes) });
					return res(JSON.parse(fetchedRecommendations));	
				}
			});

			// 获取推荐商品。生成页面
			const promiseSyncProdArr = promiseFetchReco.then((data) => {
				this.renderRecommendations(false, data, 'indexMapProductsLabeledBaseline');
				this.renderRecommendations(false, data, 'indexMapProductsLabeledTarget');
				this.renderRecommendations(false, data, 'indexMapProductsLabeledAboveAndBeyond');
				return data;
			}).then((data) => {
				// 去掉用户Recommendations 页面的 automatic add to cart
				// if (this.state.isFirstTime) {
				// 	this.saveCartForFirstVisit(this.firstProdInRowArr);
				// }  
			});

			// let promiseChain = [promiseGetAccountInfo, promiseFetchReco];
			let promiseChain = [promiseGetAccountInfo];
			if (this.mounted) Promise.all(promiseChain)
			.then((data) => {
				// if (!fetchedDpStatus || localStorage.getItem("recodpstatus") === "not-started") {

				// productArr 用来装，加入购物车的数据。我也是醉了
				this.setState({productArr: this.props.cartGoodsList },()=>{
					this.calculatePrice();
				})

				this.checkDefaultPurchaseStatus();
				// } 
				// else {
				// 	this.setState({
				// 		defaultPurchaseStatus: localStorage.getItem("recodpstatus"),
				// 		defaultPurchaseStartTime: localStorage.getItem("recodpstart"),
				// 		defaultPurchaseEndTime: localStorage.getItem("recodppurchase")
				// 	});
				// }
				return data;
			}).then((data) => {
					// if (!localStorage.getItem("recohasnotpurchased") && !localStorage.getItem("recohaspurchased")) {
						this.checkIfPreviouslyPurchased();
					// } else {
					// 	if (localStorage.getItem("recohasnotpurchased")) this.setState({ eligiblePreviouslyPurchased: true });
					// }
				return data;
			})
			// .then((data) => {
			// 	// if (!localStorage.getItem("recogatepaid")) {
			// 			// this.checkIfPaidGateFee();
			// 			// this.checkIfCardIsOnStripe();
			// 			// this.getAmountPaidGateFee();
			// 	// } else {
			// 	// 	this.setState({ eligibleGatePaid: true });
			// 	// }
			// 	return data;
			// })
			// .then((data) => {
			// 	// if (!localStorage.getItem("recocardisonstripe")) {
			// 		this.checkIfEligibleForDiscount();
			// 	// } else {
			// 	// 	this.setState({ eligibleCardOnStripe: true });
			// 	// }
			// 	return data;
			// })
			// // .then((data) => {
			// 	// if (!localStorage.getItem("recogateamount")) {
			// 		this.getAmountPaidGateFee();
			// 	// } else {
			// 		// this.setState({ amountPaidGateFee: parseFloat(localStorage.getItem("recogateamount")) });
			// 		// if (localStorage.getItem("recoeligiblefordiscount")) this.setState({ eligibleForDiscount: true });
			// 	// }
			// 	return data;
			// })
			// // .then((data) => {
			// 	// if (!localStorage.getItem("recoeligiblefordiscount")) {
					
			// 	// } else {
			// 	// 	this.setState({ eligibleForDiscount: true });
			// 	// }
			// 	// return data;
			// })
			.then((data) => {
				
				if(this.state.paymentType == 'PLAN_ONE'){
					this.setState({ loading: false });
					setTimeout(()=>{
						this.setState({ 
							openScheduleConfirmModal:true,
							oneVisitSchedule:true,
						 });
					},15000);
				}else{
						this.setState({ 
							loading: false
						 });
				}
				
					// \, () => {
					// if (this.state.isFirstTime) {
					// 	this.setState({ runTutorial: true });
					// }
				// });
			})
			.catch(err => {
				console.log(err);
				alert("There was a problem fetching data: "  + err)
			});
		} else {
			this.props.history.push('/signin');
			return;
		}

			// 获取需要评论的商品。用户最后一次购物的订单商品
			HttpUtils.get("/api/user-order-products/review?user-id="+localStorage.getItem("user_id")).then(response =>{
				this.setState({
					productInfo: response
			},()=>{
					if(response.length > 0){
						this.setState({openReviewModal: true})
					}else{
						this.setState({openReviewModal: false})
				}
			})
			}).catch(err => {
					console.log(err.statusText);
			})
	}

	componentDidUpdate(){
		var recommendationDom = document.getElementById("recommendation-page");
		if(recommendationDom){
			recommendationDom.addEventListener('touchstart', this.touchStart);
			recommendationDom.addEventListener('touchmove', this.preventTouch, {passive: false});
		}
	}

	componentWillUnmount() {
		window.removeEventListener('touchstart', this.touchStart);
		window.removeEventListener('touchmove', this.preventTouch, {passive: false});
		window.removeEventListener('scroll', this.handleScroll);
		this.mounted = false;
	}

	fun_recNavigationSection(id){
		try {
			this.setState({
				navigationSectionName: id
			});
			var defaultDuration = 777 // ms
			var edgeOffset = 160; // px
			
			if(isMobile(navigator.userAgent)){
				edgeOffset = 200;
			}

			let anchor = document.getElementById(id);

			zenscroll.setup(defaultDuration, edgeOffset)
			zenscroll.to(anchor);
		} catch (error) {
			console.log(error)
		}
	}

	fun_getUserSkinType(){
		try {
			let user_account_info = localStorage.getItem("user_account_info");
			if(util.isJSON(user_account_info)){
				var responseJson = JSON.parse(user_account_info);
				var skinTypeOneWord = responseJson['skinType'].substr(0,1);
				var skintypeValue = "";
				if(skinTypeOneWord == 'O'){
					skintypeValue = 'oily';
				}else if(skinTypeOneWord == 'C'){
					skintypeValue = 'combination';
				}else{
					skintypeValue = 'dry';
				}
				this.setState({
					skinTypeOneWord:skintypeValue
				})
			}else{
				
			}
		} catch (error) {
			console.error(error);
		}
	}

	fun_getUserSignupSource(){
		try {
			let user_account_info = localStorage.getItem("user_account_info");
			if(util.isJSON(user_account_info)){
				var responseJson = JSON.parse(user_account_info);
				localStorage.setItem('user_global_enrollFrom',responseJson['enrollFrom'])
			}
		} catch (error) {
			console.error(error);
		}
	}


	fun_getUserSkinConcerns(){
		let user_account_info = localStorage.getItem("user_account_info");
		var elementConcerns = "";
		if(util.isJSON(user_account_info)){
		  var responseJson = JSON.parse(user_account_info);
		  try {
			elementConcerns = responseJson['skinConcerns'].map((element, index) => {
				if(element['option'].toLowerCase().replace(/\s*/g,"") == "notsure" || element['option'].toLowerCase().replace(/\s*/g,"") == "other" ){
					return (null)
				}else{
					return (
						<li key={index}>
							<img src= { "/images/recommendations/skinConcerns/"+ element['option'].toLowerCase().replace(/\s*/g,"") +".svg" }  />
							<span className="h5-title">{element['option']}</span>
						</li>
					  )
				}
			  
			});	  
		  } catch (error) {
			  console.error(error)
		  }
		}
		return elementConcerns;
	}

	
	touchStart(e){
		this.firstClientX = e.touches[0].clientX;
		this.firstClientY = e.touches[0].clientY;
	}
	
	preventTouch(e){
		const minValue = 10; // threshold
		this.clientX = e.touches[0].clientX - this.firstClientX;
		this.clientY = e.touches[0].clientY - this.firstClientY;
	
		// Vertical scrolling does not work when you start swiping horizontally.
		if(Math.abs(this.clientX) > minValue){ 
			e.preventDefault();
			e.returnValue = false;
			return false;
		}
	}

	handleScroll = (e) =>{
		// if (document.documentElement.scrollHeight - document.documentElement.scrollTop <= document.documentElement.clientHeight + 380) {
		// 	let fxDom = document.getElementsByClassName('refill-price-section')
		// 	if (fxDom.length > 0) {
		// 	  fxDom[0].classList.remove('flex-bottom')
		// 	}
		//   } else {
		// 	let fxDom = document.getElementsByClassName('refill-price-section')
		// 	if (fxDom.length > 0) {
		// 		fxDom[0].classList.add('flex-bottom')
		// 	}
		// }
		
			if(document.documentElement.scrollTop>0 && document.documentElement.scrollTop < document.getElementsByClassName("target-recommdations-produs")[0].offsetTop-200 ){
				this.setState({
					navigationSectionName: 'buildaHealthySkinBaseline_id'
				});
			}else if(document.documentElement.scrollTop >  (document.getElementsByClassName("target-recommdations-produs")[0].offsetTop-200)  && document.documentElement.scrollTop < document.getElementsByClassName("beyond-recommdations-produs")[0].offsetTop-100 ){
				this.setState({
					navigationSectionName: 'targetYourConcerns_id'
				});
			}else if(document.documentElement.scrollTop > (document.getElementsByClassName("beyond-recommdations-produs")[0].offsetTop )){
				this.setState({
					navigationSectionName: 'goAboveAndBeyond_id'
				});
			}else if(isMobile(navigator.userAgent)){
				if(document.documentElement.scrollTop > (document.getElementsByClassName("beyond-recommdations-produs")[0].offsetTop -958 )){
					this.setState({
						navigationSectionName: 'goAboveAndBeyond_id'
					});
				}
			}


		if(document.getElementById("phone-recommendations-navigation-area")){
			document.getElementById("phone-recommendations-navigation-area").style.top =  document.getElementById("promo-banner-container-second").offsetHeight +'px';
		}

		if(document.getElementById("pc-recommendations-navigation-area")){
			document.getElementById("pc-recommendations-navigation-area").style.top =  document.getElementById("promo-banner-container-second").offsetHeight +'px';
		}
	}

	

	//Force Rerender to sync front end with cart after closing Checkout window
	forceRender = () => {
		this.renderRecommendations(false, this.state.recommendedProducts);
		this.setState({ loading: true }, () => {
				this.setState({ loading: false });
		});
	}



	// //Tutorial Callbackl
	tutorialCallback = (data) => {
		const { action, index, type,status } = data;
		// if( (action === "update" && index == 2)  || (action === "update" && index == 3) ){
		// 	console.log(data)
		// 	// document.documentElement.scrollTop = 150
		// 	let anchor = document.getElementsByClassName("image-holder")[0]
		//  	zenscroll.center(anchor);
		// }

		if(window.innerWidth < 768){
			if(  action === "update" && index == 0 ){
				setTimeout(function(){
					window.scrollTo(0,0);
				},1000)
			}
	
			if(  action === "update" && index == 2 ){
				setTimeout(function(){
					window.scrollTo(0,40);
				},1000)
			}
		}
		//  this.setState({ runTutorial: false });
		// if (type === EVENTS.TOUR_END || (type === EVENTS.STEP_AFTER && index === 4)) return;
	}



	//Get Account Info
	getAccountInfo = () => {
		return fetch('/api/user-account-info/' + this.userId, {
			method: 'GET',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
				'x-auth-token': this.authToken
			}
		}).then((response) => response.json()).then(responseJson => {
			this.setState({ 
				firstName: responseJson.firstName, 
				lastName: responseJson.lastName,
				phoneNumber: responseJson.phoneNumber, 
				email: responseJson.email
			});
		}).catch(function(err) {
			console.log("There was a problem fetching your account info. Please try again.");
		});
	}
		
	//Fetch Recommended Products
	fetchRecommendedProducts = (additionalRecs, callback) => {
		let url = !additionalRecs ? "/api/surveys/result?user-id="+this.userId : "/api/surveys/extra-recommendation?user-id="+this.userId;

		if(localStorage.getItem("user_global_enrollFrom") == "popup"){
			url = url+'&is-for-popup=true'
		}

		fetch(url, {
			method: "GET",
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json",
				"x-auth-token": this.authToken
			}
		}).then(response => response.json())
		.then(responseJson => {
			this.setState({
				recommendedProducts: responseJson.recommendedProducts,
				productTypes:  responseJson.productTypes
			}, () => {

				const localData = JSON.stringify(this.state.recommendedProducts);
				localStorage.setItem("recommendations_fetched", localData);

				if(!additionalRecs){
					

					try {
						

						let estheticianNoteData = responseJson['estheticianNote'];

						localStorage.setItem("estheticianNote", estheticianNoteData);

						if(estheticianNoteData.length > 170){
							let estheticianNoteDataShowText = estheticianNoteData.substring(0,150);
							this.setState({
								estheticianNote: estheticianNoteData,
								estheticianNoteDataShowText:estheticianNoteDataShowText+"...",
							});
						}else{
							this.setState({
								estheticianNote: estheticianNoteData,
								estheticianNoteDataShowText: estheticianNoteData
							});
						}
					} catch (error) {
						console.error(error);
					}
				}
				 

				const localDataProductTypes = JSON.stringify(this.state.productTypes);
				// localStorage.setItem("recommendations_fetched_product_types", localDataProductTypes);
				callback();
			});
		})
		.catch(function(err) {
			console.log(err);
		});
	};

	/*** ADDITIONAL RECOMMENDATIONS ***/
    getAdditionalRecommendations() {
        const userId = localStorage.getItem("user_id");
        fetch('/api/surveys/extra-recommendation?user-id=' + userId, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-auth-token': localStorage.getItem("auth_token")
            }
        })
        .then((response) => response.json())
        .then(responseJson => {
            this.setState({
                additionalRecommendedProducts: responseJson
            });
        })
        .catch(function(err) {
            console.log("There was a problem to getting your additional recommendations. Please try again.");
        });
	}
	
	handleOpenAdditionalCategories() {
        this.setState({ openAdditionalCategories: !this.state.openAdditionalCategories });
	}

	//DEFAULT PURCHASE PROCESS RELATED
	checkIfPreviouslyPurchased = () => {
		fetch('/api/user-orders/extended-with-products?user-id=' + this.userId, {
			method: 'GET',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
				'x-auth-token': this.authToken
			}
		}).then((response) => {
			if (response.status >= 400 && response.status < 500) return;
			else return response.json();
		}).then(responseJson => {
			if (responseJson && responseJson.length < 1) {
				this.setState({ eligiblePreviouslyPurchased: true });
				localStorage.setItem("recohasnotpurchased", true);
				this.checkIfPaidGateFee();
			} else {
				return;
				// localStorage.setItem("recohaspurchased", true)
			}
		}).catch(function(err) {
			console.log(err)
		});
	}
		
	checkIfPaidGateFee = () => {
		fetch('/api/user-flags/gate-fee-paid?user-id=' + this.userId, {
			method: 'GET',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
				'x-auth-token': this.authToken
			}
		}).then((response) => response.json()).then(responseJson => {
			if (responseJson) {
				this.setState({ eligibleGatePaid: true });
				localStorage.setItem("recogatepaid", true);
				localStorage.setItem("gateFeePaid","true");
				this.setState({ userPaidGateFee: true });
				this.checkIfCardIsOnStripe();
			}
		}).catch(function(err) {
			console.log("There was a problem getting the confirmation code. Please try again.");
		});
	}

	/*** DEFAULT PURCHASE API CALLS ***/
	checkIfCardIsOnStripe = () => {
		fetch('/api/stripe-customers/status?user-id=' + this.userId, {
			method: 'GET',
			headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'x-auth-token': this.authToken
			}
		}).then(response => response.json())
		.then(responseJson => {
			if (responseJson) {
				localStorage.setItem("recocardisonstripe", true);
				this.setState({ eligibleCardOnStripe: true });

				this.getAmountPaidGateFee();  //
				// this.getPlanTypeTierData(true);

				// if (!localStorage.getItem("recoeligiblefordiscount")) localStorage.setItem("recoeligiblefordiscount", true);
			} else {

				this.getAmountPaidGateFee();
				// localStorage.setItem("recocardisonstripe", false);
			}
		}).catch(err => {
			alert('There was a problem checking for eligibility: ' + err);
		});
	}

	checkIfEligibleForDiscount = () => {
		if (( this.state.defaultPurchaseStatus === "started"  && this.state.eligibleCardOnStripe && this.state.eligibleGatePaid) && this.state.eligiblePreviouslyPurchased) {
			console.log("Passes test");
			this.setState({ eligibleForDiscount: true });
			localStorage.setItem('recoeligiblefordiscount', true);
		}
		// It can be deducted after saving money
		if(this.state.amountPaidGateFee){
			this.setState({ eligibleForDiscount: true });
			localStorage.setItem('recoeligiblefordiscount', true);
		}

	}

	getPlanTypeTierData = (isOneShoop) => {
		const userId = localStorage.getItem("user_id");
			fetch('/api/user-profiles/tier?user-id=' + userId, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-auth-token': Api.auth_tokenManager()
            }
			}).then((response) => response.json()).then(responseJson => {
					try {
							let amountPaidGateFee = 0;
							if(responseJson == 1){
								amountPaidGateFee = 0;
							}else if(responseJson == 2){
								amountPaidGateFee = 10;
							}else if(responseJson == 3){
								amountPaidGateFee = 20;
							}else if(responseJson == 5){
								amountPaidGateFee = 10;
							}
							localStorage.setItem("planTier", responseJson);
							this.setState({
								planTier:responseJson
							})
							if(isOneShoop){
								this.setState({ amountPaidGateFee: amountPaidGateFee });
								localStorage.setItem("recogateamount", amountPaidGateFee);
							}

							if (amountPaidGateFee > 0) {
								this.checkIfEligibleForDiscount();
							}

					} catch (error) {
					}  
			}).catch(function(err) {
					console.log("resp");
			});
	}

	getAmountPaidGateFee = () => {
		const url = '/api/gate-fees?user-id=' + this.userId;
		fetch(url, {
			method: 'GET',
			headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'x-auth-token': this.authToken
			}
		}).then((response) => {
			if (response.status >= 200 && response.status < 300) {
				let contentLength = parseInt(response.headers.get("content-length"), 10);
				if (contentLength === 0) {
						return null;
				} else {
						return response.json();
				}
			} else {
				this.setState({ amountPaidGateFee: 10 });
			}
		}).then(responseJson => {
			if ((responseJson === null || responseJson === undefined) || (responseJson && responseJson.length < 1)) {
				this.setState({ amountPaidGateFee: 10 });
				localStorage.setItem("recogateamount", 10);
			} else {
				this.setState({ amountPaidGateFee: responseJson.amount });
				localStorage.setItem("recogateamount", responseJson.amount);
			}

			if (responseJson.amount > 0) {
				this.checkIfEligibleForDiscount();
			}
		}).catch(function(err) {
				console.log("resp");
		});
	}

	handleOptOut = () => {
		const userId = localStorage.getItem("user_id");
		fetch('/api/default-purchases/opt-out?user-id=' + userId, {
				method: 'POST',
				headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'x-auth-token': Api.auth_tokenManager()
				}
		})
		.then(response => {
				if (response.status === RESPONSE_STATUS.OK || (response.status >= 200 && response.status < 300)) {
						this.setState({ defaultPurchaseStatus: "opt-out", openCancelModal: false }, () => {
								// this.props.defaultPurchaseStatus("opt-out");
								const url = 'https://hooks.zapier.com/hooks/catch/2569749/0yrokb/';
								/* const url = 'https://hooks.zapier.com/hooks/catch/2569749/oo5yzaj/'; */
								const date = new Date();
								// const phone = "+1 " + this.formatPhoneNumber(this.state.phoneNumber);
								const phone = `+${localStorage.getItem("phoneCountryNumber")} ${this.formatPhoneNumber(this.state.phoneNumber)}`;
								fetch(url, {
										method: 'POST',
										body: JSON.stringify({
												"fields": {
														"First Name": this.state.firstName,
														"Last Name": this.state.lastName,
														"Phone": phone,
														"Timestamp": util.convertToStandardTime(date.getTime() / 1000),
														"Email": this.state.email
												}
										})
								}).then(response => {
								    return response.json();
								}).then(responseJson => {
									window.location.reload()
								}).catch(function(err) {
										alert("There was a problem opting out. Please try again.");
								});
						});
				} else {
						throw new Error("Server response error.")
				}
		})
		.catch(err => {
				alert('There was a problem opting out of your purchase: ' + err);
		});

	}

	formatPhoneNumber(phoneNumberString) {
		let cleaned = ('' + phoneNumberString).replace(/\D/g, '');
		if(localStorage.getItem("phoneCountry") == "UK"){
			return cleaned;
		}else{
				let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
				if (match) {
						return '(' + match[1] + ') ' + match[2] + '-' + match[3];
				}
		}
		return null;
	}
	

	//DEFAULT PURCHASE PROCESS
	//This component handles fetching the card and the function
	//for saving the cart for later. This function is called
	//by Product components.
	checkDefaultPurchaseStatus = () => {
		return fetch('/api/default-purchases?user-id=' + this.userId, {
			method: 'GET',
			headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'x-auth-token': this.authToken
			}
		}).then(response => {
			if (response.status >= 400 && response.status < 500) {
				this.startTimerOptIn();
				this.setState({ defaultPurchaseStatus: "not-started" });
				localStorage.setItem("recodpstatus", "not-started");
				throw new Error("pass");
			} else {
				return response.json();
			}
		}).then(responseJson => {
			// if (responseJson.status && ((responseJson.status === "complete") || (responseJson.status === "opt-out"))) {
			// 	localStorage.setItem("recodpstatus", responseJson.status);
			// } else {
			// 	localStorage.setItem("recodpstatus", "started");
			// }
			// localStorage.setItem("recodpstart", responseJson.createdDate);
			this.setState({ defaultPurchaseStartTime: responseJson.createdDate });
			// localStorage.setItem("recodppurchase", responseJson.status === "opt-out" ? responseJson.lastModifiedDate : null);
			this.setState({defaultPurchaseStatus: responseJson.status, defaultPurchaseEndTime: responseJson.status === "opt-out" || responseJson.status === "complete" ? responseJson.lastModifiedDate : null });


		}).catch(err => {
			return;
			// else alert("There was a problem checking the user's default purchase status: " + err);
		});
	}

	startTimerOptIn = () => {
		fetch('/api/default-purchases/start?user-id=' + this.userId, {
			method: 'POST',
			headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'x-auth-token': this.authToken
			}
		})
		.then((response) => {
			if (response.status >= 200 || response.status < 300) {
				fetch('/api/default-purchases?user-id=' + this.userId, {
						method: 'GET',
						headers: {
								'Accept': 'application/json',
								'Content-Type': 'application/json',
								'x-auth-token': this.authToken
						}
				}).then(response => response.json())
				.then(responseJson => {
					localStorage.setItem("recodpstatus", "started");
					if(this.state.user_flags_show_recommendation == 'false'){
						this.setState({ runTutorial: true, defaultPurchaseStatus: "started", defaultPurchaseStartTime: responseJson.createdDate })
					}else{
						this.setState({defaultPurchaseStatus: "started", defaultPurchaseStartTime: responseJson.createdDate })
					}


					const url = 'https://hooks.zapier.com/hooks/catch/2569749/0z8ws2/';
					fetch(url, {
							method: 'POST',
							body: JSON.stringify({
									"First Name": this.state.firstName,
									"Last Name": this.state.lastName,
									"Phone": '+'+localStorage.getItem("phoneCountryNumber")+' '+this.formatPhoneNumber(this.state.phoneNumber),
									// "Phone": this.state.phoneNumber,
									"Email": this.state.email
							})
					}).then(
						// this.setState({ runTutorial: true, defaultPurchaseStatus: "started", defaultPurchaseStartTime: responseJson.createdDate })
					)
					.catch(function(err) {
							alert("There was a sending your status. Please try again.");
					});


				}).catch(err => {
						alert('There was a problem starting the  timer: ' + err);
				});
			}
		})
		.catch(err => {
				console.log('There was a problem starting the default purchase process: ' + err);
		});
	}

	saveCartForFirstVisit = (prodArr) => {
		const userId = this.userId;
		const prodStr = prodArr.map(product => `${[product.id]}:1`).toString();
		fetch('/api/carts?user-id=' + userId + '&products=' + prodStr, {
			method: 'POST',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
				'x-auth-token': this.authToken
			}
		}).then(response => {
			if ((response.status >= 200 && response.status < 300)) {
				this.setState({ productArr: prodArr }, () => {
					this.props.getUserCartData()
					localStorage.setItem("recommendations_cart_fetched_with_prod", JSON.stringify(prodArr));
					this.calculatePrice();
				});
			}

			else throw new Error("Response status error.");
		})
		.catch((err) => {
			// alert("There was a problem saving your products: " + err);
		});
	}
	
	// 清空购物车
	clearCart = () => {
		this.props.deleteAllCartGoodsData()
	}

	// 从购物车页面中删除购物车中的产品
	handleDeleteProduct = (product) => {
		let productArr = this.props.cartGoodsList;
		const ind = productArr.indexOf(product);
		let productArrCopy = [];
		if (ind < 0) {
			productArrCopy = [...productArr, product];
		} else {
			productArrCopy = [...productArr.slice(0, ind), ...productArr.slice(ind + 1)];
		}
		if (productArrCopy < 1) this.setState({ openPaymentConfirmModal: false });

		this.props.addOrDeleteCartGoodsData(product)
	}
	//END DEFAULT PURCHASE
    
	// 打开购物车，判断购物车中数量
    openPaymentConfirmModal = () => {
		const count = this.props.cartGoodsList.length
        if (count <= 0) {
            alert("You must select at least one product.");
            return;
		}
        this.setState({ openPaymentConfirmModal: true });
    }
	// 关闭付款页面/购物车页面
    closePaymentConfirmModal = () => {
        this.setState({ openPaymentConfirmModal: false, amountAvailableForDiscount: 0, discountCodes: [], promoCodeSaved: "" });
	}
	
	closeHomeConfirmModal(){
		localStorage.setItem("bannerRepulic",false)
		this.setState({
		  openHomeConfirmModal:false  
		})
	}

	closeScheduleConfirmModal(){
		this.setState({
		  openScheduleConfirmModal: !this.state.openScheduleConfirmModal
		})
	}

	closeReviewModal() {
		this.setState({
			openReviewModal: false
		})
	}

	renderRecommendations(isAdditional, recommendedProducts_param,productBigtype) {
		try {
			//ORDER OF CATEGORIES
			let productViews = [];
			var recommendedProducts = !isAdditional ? recommendedProducts_param : this.state.additionalRecommendedProducts;
			var numOfProducts = recommendedProducts.length;

			if(productBigtype == 'indexMapProductsLabeledBaseline'){
				recommendedProducts = recommendedProducts.filter(product=>{
					if( !!indexMapProductsLabeledBaseline[product.type.toLowerCase()] ){
						return product
					}
				})
				numOfProducts = recommendedProducts.length;
				recommendedProducts.sort((a, b) => {
					return indexMapProductsLabeledBaseline[a.type.toLowerCase()] - indexMapProductsLabeledBaseline[b.type.toLowerCase()];
				});

			}else if(productBigtype == 'indexMapProductsLabeledTarget'){
				recommendedProducts = recommendedProducts.filter(product=>{
					if( !!indexMapProductsLabeledTarget[product.type.toLowerCase()] ){
						return product
					}
				})
				numOfProducts = recommendedProducts.length;

				recommendedProducts.sort((a, b) => {
					return indexMapProductsLabeledTarget[a.type.toLowerCase()] - indexMapProductsLabeledTarget[b.type.toLowerCase()];
				});

			}else if(productBigtype == 'indexMapProductsLabeledAboveAndBeyond'){
				recommendedProducts = recommendedProducts.filter(product=>{
					if( !!indexMapProductsLabeledAboveAndBeyond[product.type.toLowerCase()] ){
						return product
					}
				})
				numOfProducts = recommendedProducts.length;
				
				recommendedProducts.sort((a, b) => {
					return indexMapProductsLabeledAboveAndBeyond[a.type.toLowerCase()] - indexMapProductsLabeledAboveAndBeyond[b.type.toLowerCase()];
				});

			}else {
				recommendedProducts.sort((a, b) => {
					return indexMapProductsLabeled[a.type.toLowerCase()] - indexMapProductsLabeled[b.type.toLowerCase()];
				});
			}

			recommendedProducts.forEach((product, index, arr) => {
					if(product.type !=''){
						let productType = util.capitalize(product.type);
						let recommendedProductsCopy = recommendedProducts.filter((product,index,arr) => {
										return util.capitalize(arr[index].type) === productType;
								});
	
						if (((index !== numOfProducts - 1) && (productType.toLowerCase() !== recommendedProducts[index+1].type.toLowerCase())) ||
								(index === numOfProducts - 1)
								) {

									recommendedProductsCopy.sort(function(a,b){
										if(a.estheticianPick){
											return -1
										}else if(a.estheticianPick && b.estheticianPick){
											return 0
										}else{
											1
										}
									})

								let productSliderContent = recommendedProductsCopy.map((productMap, indexMap, arr) => {
									// 去掉用户Recommendations 页面的 automatic add to cart
									// if (this.state.isFirstTime) {
									// 	if (indexMap === 0) {
									// 			this.firstProdInRowArr.push(productMap);
									// 	}
									// }				
	
										return (
												<div className={productMap.estheticianPick ? "recomment-productInfo-area esthetician-picks":"recomment-productInfo-area"} key={indexMap}>
														{
															productMap.estheticianPick ? <EstheticianPicksConten product={productMap}></EstheticianPicksConten>:null
														}

														<Product
																// productCart={ this.state.productArr }
																productCart={ this.props.cartGoodsList }
																product={productMap} index={ indexMap } key={`product-${index}`}
																isAdditionalRec={ true }
																// saveCartForLater={ this.saveCartForLater }
																saveCartForLater={ this.props.addOrDeleteCartGoodsData }
																isFirstTime={ this.state.isFirstTime }
														/>
												</div>
										);
								});
								productViews.push(
									<div className="product-row-area" key={index}>
										<Product_categoryHolder productType={productType} skinTypeOneWord={this.state.skinTypeOneWord}></Product_categoryHolder>
										<div className="recommendation-product-show-zone">
											<Slider { ...sliderSettings } >
													{ productSliderContent }
											</Slider>
										</div>
										 {/* <div className="product-right-over"></div>	 */}
									</div>
								);
						}
					}
			});
			// !isAdditional ? this.setState({ productViews: productViews }) : {}
			
			if(productBigtype == 'indexMapProductsLabeledBaseline'){
					this.setState({ productViews: productViews });
			}else if(productBigtype == 'indexMapProductsLabeledTarget'){
				this.setState({ target_productViews: productViews });
			}else if(productBigtype == 'indexMapProductsLabeledAboveAndBeyond'){
				this.setState({ aboveAndBeyond_productViews: productViews });
			}
			return productViews
		} catch (error) {
			console.log(error);
		}
	}

	renderProductCategories = () => {
		const indexMapProductsRef = {1:"Cleanser",2:"Toner",3:"Moisturizer",4:"SPF",5:"Serum",6:"Eye Cream",7:"Exfoliator",8:"Mask",11:"Make-Up Remover",12:"Treatment",13:"3-Step Regimen",14:"5-Step Regimen", 15:"Supplement"};
		
		var productTypes = [];
		if(this.state.productTypes){
			productTypes = this.state.productTypes.sort();
		}

		let outputStr = '';

		productTypes.forEach((id, index) => {
				let category;
				if (index !== productTypes.length - 1) category = indexMapProductsRef[id] + ", ";
				else category = indexMapProductsRef[id];
				outputStr += category;
		});

		return outputStr;
}

	/*** END ADDITONAL RECOMMENDATIONS ***/
	calculatePrice = () => {
		let sum = 0;
		this.state.productArr.forEach(product => {
			if (product && product.price) {
				sum += parseFloat(product.price);
			}
		});
		this.setState({ price: sum.toFixed(2) });
	}

	/*** CANCEL MODAL ***/
	openCancelModal = () => {
		this.setState({
			openCancelModal: true
		});
	}

	closeCancelModal = () => {
		this.setState({
				openCancelModal: false
		});
	}
	/*** END CANCEL MODAL ***/
	
	fun_leavingMoreOpen(){
		let estheticianNoteData = this.state.estheticianNote;
		let estheticianNoteDataShowText = "";

		if(this.state.leavingMoreOpen){
			if(estheticianNoteData.length > 170){
				estheticianNoteDataShowText = estheticianNoteData.substring(0,150)+"...";
			}else{
				estheticianNoteDataShowText = estheticianNoteData;
			}
		}else{
			estheticianNoteDataShowText = estheticianNoteData;
		}
		
		this.setState({
			estheticianNoteDataShowText: estheticianNoteDataShowText,
			leavingMoreOpen: !this.state.leavingMoreOpen
		});
	}
	
	toggleLoading= (loadingPurchase) => {
		this.setState({ loadingPurchase: loadingPurchase });
	}
	// 在购物车中，完成购买后。展示ThankYou,关闭购物车页面。清空 localStorage
	showThankYou = (orderIdValue,orderSubtotalValue,sourceOrderId,orderProductsDataValue, goodsNumber,tax, shippingRate,promoCodeSaved, gtmORderInfoTrack) => {
		this.setState({ showThankYou: false, openPaymentConfirmModal: true, runTutorial: false }, () => {
			for (let key in localStorage) {
				if (key.includes("reco") && !key.includes("enable_")) localStorage.removeItem(key);
			}
			localStorage.removeItem('cart-products-ids');
			this.props.history.push({pathname:"/showThankYou",state:{'orderId':orderIdValue,'orderSubtotal':orderSubtotalValue,'sourceOrderId':sourceOrderId,'orderProductsData':orderProductsDataValue,'orderGoodsNumber':goodsNumber,'tax':tax, 'shippingRate': shippingRate, 'promoCodeSaved': promoCodeSaved, 'gtmORderInfoTrack':gtmORderInfoTrack }});
		});
		// this.setState({
		// 	orderEnd:true, 
		// 	orderId: orderId,
		// 	orderSubtotal: orderSubtotalValue,
		// })
	}
	//  
	fun_scheduleConsultNowRout(){
		this.props.history.push({pathname :"/recommendation-landing-thank"});

		// if(this.state.planValue == 'PLAN_ONE' || this.state.planTier == "5" ){
		// 	this.props.history.push({pathname :"/recommendation-landing",state:{planValue:15,paymentType:'UPSELL'}});
		// }else if(localStorage.getItem("gateFeePaid") == "true" ){
		// 	this.props.history.push({pathname :"/recommendation-landing-thank"});
		// }else{
		// 	this.props.history.push({pathname :"/recommendation-landing",state:{planValue:15,paymentType:'UPSELL'}});
		// }

	}

    render() {
		if (this.state.loading || this.state.loadingPurchase ) return <LoadingBlock purchase={ this.state.loadingPurchase } />
		else  return ( 	
			<div id="recommendation-page" className={ this.state.defaultPurchaseStatus === "started" ? "recommendations-page" : "recommendations-page no-steps-header_no" }>
				<Helmet>
					<title>Personalized skincare product for your unique skin</title>
					<meta name="description" content="Join the HelloAva skincare revolution today! A community of 150,000 women and men who have found the right products for their skin types." />
					{/* <meta name="canonical" content= "Join the HelloAva skincare revolution today! A community of 150,000 women and men who have found the right products for their skin types." /> */}
				</Helmet>
{/* 
				<div style={this.state.planTier == 1 || localStorage.getItem("planTier") == "5" || this.state.planTier == 4 || localStorage.getItem("planTier") == "4" || this.state.planTier == 5 ||  localStorage.getItem("planTier") == "1" || this.state.paymentType == "PLAN_ONE" ? {display:'none'} : {width:'100%'}}>
					{
						this.state.defaultPurchaseStatus  === "started" ?
							( !this.state.showThankYou ? <StepsHeader step={3} /> : <StepsHeader step={4} /> ) :
							null
					}
				</div> */}
										
				<div className="recommendations-container">
						{/* !this.state.showThankYou ? <div className="price-match">
								<a href="/price-matching"><div className="price-match-message"><img alt="Price matching" src="/images/onboarding/price-match.svg" />We Price Match</div></a>
								</div> : null*/ }
						<div id="final-thank-you" className={this.state.showThankYou ? "checkout-block final-thank-you-block" : "checkout-block final-thank-you-block collapsed"}>
								<div className="thank-you-container"><img alt="Thank You!" src="/images/gate/thank-you.png" /></div>
								<div className="final-thank-you-message">
										<p>
										Your order will take about 1-2 days to process.
										</p>
								</div>
								<div className="final-thank-you-buttons">
										<div className="checkout-block-button hidden" >
										<button><a href="/orders">Check order history</a></button>
								</div>
										<div className="checkout-block-button hidden" >
												<button><a href="/recommendations">Back to Recommendations</a></button>
										</div>
								</div>
								<div className="social-icons">
										<div className="follow">Follow us:</div>
										<div className="social-icon-group">
												{/* <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/HelloAVAbeauty/"><FaFacebook size={22} className="follow-icons facebook-icon" /></a>
												<a target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/helloavabeauty/"><FaInstagram size={22} className="follow-icons insta-icon" /></a> */}
												<a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/HelloAVAbeauty/"><i className="fa fa-facebook-square" aria-hidden="true" style={{fontSize:'1.3em'}}></i></a>
												<a target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/helloavabeauty/"><i className="fa fa-instagram" aria-hidden="true"  style={{fontSize:'1.3em'}}></i></a>
										</div>
								</div>
						</div>

						<div id="recommendation-section" className={!this.state.showThankYou ? "recommendation-section" : "recommendation-section collapsed"}>
								<div className="recommendation-body">
									<div name="recommendation-body-section">
														<div className="tutorial">
															<Tutorial
																steps={ tutorialSteps }
																// 暂时注释教程
																// run={ this.state.runTutorial }
																run={ false }
																callback={ this.tutorialCallback }
																scrollOffset = {300}
																scrollToSteps={true}
																debug={ false }
																disableScrolling={ false }
																continuous={ true }
																styles={{
																		buttonNext: {
																				backgroundColor: '#ffad94',
																				color: '#fff',
																				borderRadius: '13.4px',
																				fontSize: '9px',
																				width: '65px',
																				fontFamily: 'Montserrat',
																				fontWeight: '600'
																		},
																		buttonBack: {
																				color: '#9b9b9b',
																				fontSize: '12px',
																				marginLeft: '0'
																		},
																		options: {
																				overlayColor: 'rgba(0, 0, 0, 0.2)'

																		},
																		tooltipContent: {
																			padding: '7px 10px',
																		},
																		spotlight:{
																			// backgroundColor:'#ffffff',
																			// opacity:0.5,
																			borderRadius: '10px',
																		},
																		tooltipTitle:{
																			fontSize:'13px'
																		}
																}}
																spotlightClicks={false}
																scrollToFirstStep={ true }
															/>
														</div>


								<div className="recommendations-bundle separate-view">
									<div className="top-info-section">
										<div className="recommendation-section-area">
											<div className="steps">
												<div className="step step-two">
													<i className="letter-icon"></i>
												</div>
											</div>

											<div className="upper-section-wrapper">
													<div className="upper-section">
														<div className="your-plan heading_alt1"> Routine made for { util.capitalize(localStorage.getItem("user_firstname")) }</div>
													</div>
											</div>

											<div className="recommendations-title-info paragraph1 navy">The recommendations below reflect your skin type and your  skin concerns, and matched with our exclusive database of clinical research. </div>

											<div className="skinConcerns-section">
												<ul>{this.fun_getUserSkinConcerns()} </ul>
											</div>
											{
												(localStorage.getItem("estheticianNote") && localStorage.getItem("estheticianNote")!= '' )  && this.state.estheticianNote != '' && this.state.estheticianNote != null ?
												<div className="paragraphRegular4 leaving-a-message-area">
													<div className="leaving-a-message-title-slogan paragraphSemiBold2">Esthetician Notes</div>
													<div className="leaving-a-message-title-conten">
														{/* <div className="leaving-a-message-title-hello">Hello {this.state.firstName},</div> */}
														<div className="leaving-a-message-text" dangerouslySetInnerHTML={{__html: this.state.estheticianNoteDataShowText}}></div>
														{
															this.state.estheticianNote.length > 170 ? <div className="paragraphRegular4 leaving-a-message-more" onClick={this.fun_leavingMoreOpen}>More { this.state.leavingMoreOpen ? <i className="fa fa-angle-up fa-fw"></i>  : <i className="fa fa-angle-down fa-fw"></i>} </div>:null
														}
													</div>
													{/* <div className="leaving-a-message-img-area">
														<img className="headPortrait-icon" src="../images/recommendations/estheticianPicks/kimberlyBrooms.png"></img>
														<img className="autograph" src="../images/recommendations/estheticianPicks/kimberlyBroomsAutograph.svg"></img>
													</div> */}
												</div>:null
											}					

											{/* <div className="lets-go-section h4-title blue_green">Let’s go  <img src="/images/recommendations/arrayBottom.svg"/></div> */}
										</div>
										<img className="let_top_spot" src="/images/recommendations/leBlueBg.svg"></img>
										<img className="ri_bottom_spot" src="/images/recommendations/riBlueBg.svg"></img>
									</div>

									<Responsive minWidth={ 776 }>
										<div className="recommendations-navigation-area pc-recommendations-navigation-area" id="pc-recommendations-navigation-area">
											<ul className="recommendations-navigation-ul paragraph2">
												<li className={this.state.navigationSectionName == 'buildaHealthySkinBaseline_id' ? "action": null } onClick={()=>{ this.fun_recNavigationSection('buildaHealthySkinBaseline_id') }}>Build a healthy skin baseline</li>
												<li className={this.state.navigationSectionName == 'targetYourConcerns_id' ? "action": null } onClick={()=>{ this.fun_recNavigationSection('targetYourConcerns_id') }}>Target your concerns</li>
												<li className={this.state.navigationSectionName == 'goAboveAndBeyond_id' ? "action": null } onClick={()=>{ this.fun_recNavigationSection('goAboveAndBeyond_id') }}>Go above and beyond</li>
											</ul>
										</div>
									</Responsive>

									<Responsive maxWidth={ 776 }>
										<div className="recommendations-navigation-area phone-recommendations-navigation-area" id="phone-recommendations-navigation-area">
											<ul className="recommendations-navigation-ul paragraph2">
												<li className={this.state.navigationSectionName == 'buildaHealthySkinBaseline_id' ? "action": null } onClick={()=>{ this.fun_recNavigationSection('buildaHealthySkinBaseline_id') }}>Skin baseline</li>
												<li className={this.state.navigationSectionName == 'targetYourConcerns_id' ? "action": null } onClick={()=>{ this.fun_recNavigationSection('targetYourConcerns_id') }}>Target concerns</li>
												<li className={this.state.navigationSectionName == 'goAboveAndBeyond_id' ? "action": null } onClick={()=>{ this.fun_recNavigationSection('goAboveAndBeyond_id') }}>Above and beyond</li>
											</ul>
										</div>
									</Responsive>
									


									<div className="baseline-recommdations-produs recommendation-section-area">
										<div className="navigation-title-area">
											<div className="heading1" id="buildaHealthySkinBaseline_id">Build a healthy skin baseline</div>
											<div className="paragraphRegular2 navigation-title-conten navy">The core for taking care of  dry skin is locking moisture into your skin and protecting your skin’s natural moisture barrier. </div>
											<div className="navigation-title-area-solid"></div>
										</div>

										<div className="recommendation-section-product-area products">
												{ 
													this.state.productViews
												}
										</div>
									</div>


									<div className="target-recommdations-produs">
										<div className="recommendation-section-area">
											<div className="navigation-title-area">
												<div className="heading1" id="targetYourConcerns_id">Target your concerns</div>
												<div className="paragraphRegular2 navigation-title-conten navy">Once your baseline is all set, complement your regimen with products that focus deeper on your main skin concerns. </div>
												<div className="navigation-title-area-solid"></div>
											</div>

											<div className="recommendation-section-product-area products">
													{ 
														this.state.target_productViews
													}
											</div>
										</div>
									
									</div>
								
									<div className="beyond-recommdations-produs recommendation-section-area">
										<div className="navigation-title-area">
											<div className="heading1" id="goAboveAndBeyond_id">Go above and beyond</div>
											<div className="paragraphRegular2 navigation-title-conten navy">Striving for perfection? We got you. Press the reset button on your skin once a week or approach it more holistically, we are here to help you take your routine to the next level.</div>
											<div className="navigation-title-area-solid"></div>
										</div>

										<div className="recommendation-section-product-area products">
											{ this.state.aboveAndBeyond_productViews }
										</div>
									</div>

									<div className="bottom-section-happine">
										<img src="/images/recommendations/Vector.svg"/>
										<p className="heading1">Happiness Guarantee</p>
										<div className="navy happine-text-zone"> We are confident in our selections for you. Try them, test <Responsive minWidth={ 776 }><br></br></Responsive> them out, and if there's anything you don't love, send it back.</div>
									</div>


{/* 
									{
										this.state.additionalRecommendedProducts && this.state.additionalRecommendedProducts.length > 0 ?
										<div className="view-more-section">
												<div className="view-more-title" onClick={ this.handleOpenAdditionalCategories } ><div className={ this.state.openAdditionalCategories ? "triangle rotate" : "triangle" }></div> What else is good for me?</div>
												<div className={this.state.openAdditionalCategories ? "products show" : "products"}>
														{ this.renderRecommendations(true) }
												</div>
										</div> :
										null
									} */}

									<div  style={this.state.defaultPurchaseStatus  !== "started" ? {justifyContent: 'flex-end'} : null}  className={this.state.showThankYou == true ? "refill-price-section " : "refill-price-section flex-bottom" }>
	{/* 																		
												{
													this.state.defaultPurchaseStatus  === "started" ?
														<div className="cancel-shipment">
																<a href="#/" onClick={ this.openCancelModal }>Cancel the shipment</a>
														</div> :
														null
												}
													*/}

												<div className="right-price-viewButton">
													<div className="price">

															{/* <div className="orig-price">
																	<div className="label">{ (this.state.eligibleForDiscount && (this.state.productArr.length > 0 && parseFloat(this.state.amountPaidGateFee)) > 0) ? "Subtotal" : "Total" }: </div>
																	<div className={ (this.state.eligibleForDiscount && (this.state.productArr.length > 0 && parseFloat(this.state.amountPaidGateFee)) > 0) ? "total-price" : "total-price no-strikethrough"}>{ " $" + this.props.cartPriceSum() }</div>
															</div> */}
															
															{/* {(this.state.eligibleForDiscount && (this.state.productArr.length > 0 && parseFloat(this.state.amountPaidGateFee)) > 0) ? <div className="you-save">
																	<div className="discount-offer">Consultation credit</div>
																	<div className="discount-amount" style={{marginLeft:"5px"}}>-${ parseFloat(this.state.amountPaidGateFee) }</div>
															</div> : null} */}


																<div className="discount-price">
																	<div className="label">Total:</div>
																	{/* <div className="total-price">{ "$"+ parseFloat(this.props.cartPriceSum() - this.state.amountPaidGateFee).toFixed(2) }</div> */}
																	<div className="total-price">{ "$"+ parseFloat(this.props.cartPriceSum()).toFixed(2) }</div>
															</div>

															{/* 																						
															{
																this.state.defaultPurchaseStatus  === "started" ?
																	<div className="mobile-cancel-shipment">
																			<a href="#/" onClick={ this.openCancelModal } style={{fontSize:'9px'}}>Cancel the shipment</a>
																	</div> :
																	null
															}
																*/}


																<div className="checkout-section__price-match">
																<a target="_blank" href="/price-matching" style={{fontSize: '12px',fontWeight: 'normal'}} className="checkout-section__price-match-link we-price-match">We Price Match!</a>
															</div>
													</div>
													<div>
														<button className="cart-viewButton" onClick={ this.openPaymentConfirmModal }>View<i className="view-cart-icon"></i></button>
													</div>
												</div>
										</div>
								</div>
								<Modal open={ this.state.openCancelModal } onClose={ this.closeCancelModal.bind(this) } /*little={ true }*/
										classNames={{ overlay: 'ha-overlay cancel-overlay', modal: 'ha-modal cancel-confirm-modal', closeIcon: 'ha-modal-close' }}>
												<img alt="cancel" src="/images/recommendations/cancel-icon.svg" />
												<p>
														Are you sure you want to cancel? You can still purchase at your own pace. The $10 skincare consultation fee will be credited towards your purchase.
												</p>
												<button onClick={ () => { this.setState({ openCancelModal: false }) } } >
														Never mind. I will continue my purchase
												</button>

												<a href="#/" onClick={ this.handleOptOut } >
														I would love to cancel this shipment
												</a>

								</Modal>
							</div>
						</div>
					</div>
				</div>


				<Modal open={ this.state.openPaymentConfirmModal } onClose={ this.closePaymentConfirmModal }  /*little={ true }*/
					classNames={{ overlay: 'ha-overlay payment-confirm-overlay', modal: 'ha-modal payment-confirm-modal', closeIcon: 'ha-modal-close' }} focusTrapped={ true }>
					<Elements>
							<RecommendationsCheckout
									productArr={ this.props.cartGoodsList}
									userPaidGateFee = {this.state.userPaidGateFee}
									price={ this.props.cartPriceSum() }
									// amountAvailableForDiscount={ localStorage.getItem("recogateamount") || this.state.amountAvailableForDiscount }
									discountCodes={ this.state.discountCodes }
									amountPaidGateFee={ localStorage.getItem("recogateamount") || this.state.amountPaidGateFee }
									name={ localStorage.getItem("user_firstname") + " " + localStorage.getItem("user_lastname")}
									eligibleForDiscount={ this.state.eligibleForDiscount }
									handleDeleteProduct={ this.handleDeleteProduct }
									forceRender={ this.forceRender }
									toggleLoading={ this.toggleLoading }
									showThankYou={ this.showThankYou }
									clearCart={ this.clearCart }
									hasNotPurchased={ this.state.eligiblePreviouslyPurchased }
									// saveCartForLater={ this.saveCartForLater }
									saveCartForLater={ this.props.addOrDeleteCartGoodsData }
									// productCart={ this.state.productCart }
									productCart={ this.props.cartGoodsList }
							/>
					</Elements>
				</Modal>	


				{/* 判断是否完成购买 */}
				{
					this.state.orderEnd ?
					<div>
						<img src={`https://www.shareasale.com/sale.cfm?tracking=${this.state.orderId}&amount=${this.state.orderSubtotal}&merchantID=77400&transtype=sale&sscidmode=6&sscid=${Api.fun_shareasaleGetCookie()}` } width="1" height="1"/>
						<script defer async type="text/javascript" src="https://shareasale-analytics.com/j.js"></script>
					</div>:<div></div>
				}


				{/* 活动取消了。功能隐藏*/}
				{/* 
					<div className="home-confirm-modal" style={this.state.openHomeConfirmModal && localStorage.getItem("bannerRepulic") == null  ?{display:'block'}:{display:'none'}}>
						<i className="home-modal-closeIcon" onClick={()=>{  this.closeHomeConfirmModal() }}>x</i>
						<div className="home-confirm-conten">
						<div className="left-conten">
							<img src="/images/home/mobile/logoPink.jpg"></img>
						</div>
						<div className="right-conten">
							<div className="right-conten-title">Own A Stake In </div>
							<div className="right-conten-title">The Future of Beauty</div>
							<div className="right-conten-url-but">
							<a onClick={()=>{  this.closeHomeConfirmModal() }} target={ isMobile(navigator.userAgent) ? "_self" : "_blank" } href="https://republic.co/helloava/?utm_source=helloavasiterec&utm_medium=banner&utm_campaign=recpage">Join us now</a>
							</div>
						</div>
						</div>
					</div> 
				*/}
				{/* 活动取消了。功能隐藏*/}

				{/* 	暫時關閉	 */}
				{
					false &&  (localStorage.getItem("planTier") == "1" || localStorage.getItem("planTier") == "4" || localStorage.getItem("planTier") == "5"  ) &&  this.state.oneVisitSchedule ?
					<div name="scheduleComponent">
						<div className="schedule-confirm-modal" style={this.state.openScheduleConfirmModal  ?{display:'block'}:{display:'none'}}>
								<div className="bg-over"></div>
								<div className="schedule-consultation-area">
									<i className="schedule-modal-closeIcon" onClick={()=>{  this.closeScheduleConfirmModal() }}></i>

									<div className="schedule-consultation-body">
											<div className="top-img-tile">
											{/* <img src="/images/recommendations/MaskGroup.svg"></img> */}
												<img src="https://res.cloudinary.com/dhybuxeqg/image/upload/w_250,c_fill,ar_1:1,g_auto,r_max,/v1615540194/hello/images/recommendations/image_iblmlm.png"></img>
											</div>
											<div className="schedule-bottom-text">
												{/* <p className="heading3">Need professional help deciding?</p> */}
												<img src="/images/recommendations/Need.svg"></img>
												{/* <img className="img-text-tire" src="/images/recommendations/tire.svg"></img> */}
												<div className="img-text-tire img-text-tire-node">
													Tired of trying to figure out this skincare thing on your own? Let us do the work for you. Consult with a licensed skin expert via a 1-on-1 video call for $0.
												</div>
												{/* <ul className="schedule-text paragraph4">
													<li>Tired of trying to figure out this skincare thing on</li>
													<li>your own? Let us do the work for you. You will also</li>
													<li>receive a $10 purchase credit.</li>
												</ul> */}
												<button className="p-a-n-button" onClick={()=>{ this.fun_scheduleConsultNowRout() }}>Consult Now</button>
											</div>
									</div>
								</div>
							</div>
							<div className="need-area-min" onClick={()=>{  this.closeScheduleConfirmModal() }} style={this.state.openScheduleConfirmModal ?{display:'none'} :{display:'flex'}}>
										<div className="need-area-min-img"><img src="https://res.cloudinary.com/dhybuxeqg/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,/v1615540194/hello/images/recommendations/image_iblmlm.png"></img></div>
										<div className="need-area-min-text">Need help deciding?</div>
							</div>
					</div>
					:null
				}
								

				<Modal open={ this.state.openReviewModal } onClose={()=>{ this.closeReviewModal() }} closeOnOverlayClick={false}
					classNames={{ overlay: 'ha-overlay reviewProduct-overlay', modal: 'reviewProduct-confirm-modal', closeIcon: 'ha-modal-close' }}>
					<ReviewProduct product={this.state.productInfo} closeReviewModal={this.closeReviewModal}></ReviewProduct>
				</Modal>

			</div>
					
		);
    }
}

function mapStateToProps(state) {
	const { helloava } = state;
    const { cartGoodsCount, cartGoodsList, cartPriceSum } = helloava.myCart;
    return {cartGoodsCount, cartGoodsList, cartPriceSum };
}

function mapDispatchToProps(dispatch) {
    return {
		addOrDeleteCartGoodsData: (product) => dispatch(addOrDeleteCartGoodsData(product)),
		deleteAllCartGoodsData: () => dispatch(deleteAllCartGoodsData()),
		getUserCartData: () => dispatch(getUserCartData())
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Recommendations));



// WEBPACK FOOTER //
// ./src/views/recommendations/Recommendations.js